<div class="container gap-4">
  <lib-header-page
    [title]="'purchaseList' | translate"
    [totalCount]="page.totalCount"
    [showBreadcrumb]="memberId ? false : true"
  >
  </lib-header-page>
  <lib-filter-section
    hasMoreFilter
    (onSubmit)="filterChange($event)"
    (onClear)="clearFilter($event)"
    contentStyleClass="formgrid lg:grid-cols-4  md:grid-cols-3 grid-cols-1"
  >
    <!-- <div class="formgrid lg:grid-cols-4  md:grid-cols-3 sm:grid-cols-1"> -->
    @if(!memberId){
    <div class="field">
      <label for="memberId">{{ "membershipNumber" | translate }}</label>
      <input
        type="text"
        pInputText
        id="memberId"
        name="memberId"
        [(ngModel)]="filter.memberId"
      />
    </div>
    }

    <div class="field">
      <label for="memberName">{{ "memberName" | translate }}</label>
      <input
        type="text"
        pInputText
        id="memberName"
        name="memberName"
        [(ngModel)]="filter.memberName"
      />
    </div>

    <div class="field">
      <label for="purchaseNo">{{ "shippingTicketNumber" | translate }}</label>
      <input
        type="text"
        pInputText
        id="purchaseNo"
        name="purchaseNo"
        [(ngModel)]="filter.purchaseNo"
      />
    </div>

    <!-- <div class="field">
      <label for="productCategory">{{ "productCategory" | translate }}</label>
      <shared-product-category-dropdown
        isPrimitive
        id="productCategory"
        name="productCategory"
        [(ngModel)]="filter.productCategory"
      >
      </shared-product-category-dropdown>
    </div> -->

    <!--
    </div> -->
    <ng-container moreFilter>
      <!-- <div class="field">
        <label for="product">{{ "product" | translate }}</label>
        <input
          type="text"
          pInputText
          id="product"
          name="product"
          [(ngModel)]="filter.product"
        />
      </div> -->

      @if(!locationId){
      <div class="field">
        <label for="wdc">{{ "wpnBranchesThatBuy" | translate }}</label>
        <shared-branch-dropdown
          isPrimitive
          id="wdc"
          name="wdc"
          [(ngModel)]="filter.wdc"
          [type]="branchesTypeEnum.Wpn"
        >
        </shared-branch-dropdown>
      </div>
      <div class="field">
        <label for="franchise">{{ "franchiseBranchesThatAcceptPurchases" | translate }}</label>
        <shared-branch-dropdown
          isPrimitive
          id="franchise"
          name="franchise"
          [(ngModel)]="filter.franchise"
          [type]="branchesTypeEnum.Franchise"
          isPrimitive
        >
        </shared-branch-dropdown>

      </div>
      }

      <div class="field col">
        <label for="createdAt">{{ "date" | translate }}</label>
        <lib-date-picker
          [(ngModel)]="filter.createdAt"
          id="createdAt"
          name="createdAt"
        />
      </div>

      <div class="field">
        <label for="totalAmountFrom">{{ "totalAmountFrom" | translate }}</label>

        <p-inputnumber
          id="totalAmountFrom"
          name="totalAmountFrom"
          inputId="integeronly"
          [(ngModel)]="filter.totalAmountFrom"
        />
      </div>

      <div class="field">
        <label for="totalAmountNotMoreThan">{{ "amountNotMoreThan" | translate }}</label>
        <p-inputnumber
          id="totalAmountNotMoreThan"
          name="totalAmountNotMoreThan"
          inputId="integeronly"
          [(ngModel)]="filter.totalAmountNotMoreThan"
        />
      </div>

      <div class="field">
        <label for="purchasingStaff">{{ "purchasingStaff" | translate }}</label>
        <shared-user-dropdown
          isPrimitive
          id="purchasingStaff"
          name="purchasingStaff"
          [(ngModel)]="filter.recordedBy"
        >
        </shared-user-dropdown>
      </div>
      <div class="field">
        <label for="auditor">{{ "examine" | translate }}</label>
        <shared-user-dropdown
          isPrimitive
          id="auditor"
          name="auditor"
          [(ngModel)]="filter.approvedBy"
        >
        </shared-user-dropdown>
      </div>
      <div class="field">
        <label for="personcount">{{ "purchaseDetailList.cashier" | translate }}</label>
        <shared-user-dropdown
          isPrimitive
          id="personcount"
          name="personcount"
          [(ngModel)]="filter.cashier"
        >
        </shared-user-dropdown>
      </div>

      <div class="field">
        <label for="status">{{ "status" | translate }}</label>
        <lib-dynamic-dropdown
          [list]="statusList"
          isPrimitive
          id="status"
          name="status"
          [(ngModel)]="filter.status"
        />
      </div>
    </ng-container>
  </lib-filter-section>
  <lib-grid
    #grid
    [dataSub]="dataSub"
    [columns]="columns"
    [rows]="rows"
    [(page)]="page"
    (pageChange)="pageChange()"
    [sort]="sort"
    (sortChange)="sortChange($event)"
  />
</div>

<ng-template
  #fullNameTpl
  let-row="row"
  let-value="value"
  let-column="column"
>
  {{ row.firstName }} {{ row.lastName }}
</ng-template>

<ng-template
  #startDateTpl
  let-row="row"
  let-value="value"
  let-column="column"
>
  {{ value | libDate: "date" }}
</ng-template>


<ng-template
  #purchaseNoTpl
  let-row="row"
  let-value="value"
  let-column="column"
>
  <div class="grid gap-2">
    <p-button
      label="{{ value }}"
      [link]="true"
      (click)="detail(row)"
      styleClass="p-0"
    />
    @if (row.status === statusPurchaseType.Paid) {
    <p-tag
      severity="success"
      [value]="purchaseStatusEnumText[row.status]"
      rounded
    />
    } @else if(row.status === statusPurchaseType.PendingReview) {
    <p-tag
      severity="secondary"
      [value]="purchaseStatusEnumText[row.status]"
      rounded
    />
    }@else if(row.status === statusPurchaseType.PendingPayment) {
    <p-tag
      severity="info"
      [value]="purchaseStatusEnumText[row.status]"
      rounded
    />
    }@else {
    <p-tag
      severity="danger"
      [value]="purchaseStatusEnumText[row.status]"
      rounded
    />
    }
  </div>
</ng-template>

<ng-template
  #memberIdTpl
  let-row="row"
  let-value="value"
  let-column="column"
>
  <div>
    <span>{{ value.firstname }} {{ value.lastname }}</span>
    <p-tag
      class="ml-2"
      severity="secondary"
      value="{{ value.memberTier.translations | translations:'name' }}"
      [rounded]="true"
    />
  </div>

  <!-- NOTE: รอคุยกับพี่คีย์ -->
  <!-- <div *ngIf="row.typeMember !== 'member'">
    <div>
      <p-button
        label="{{ row.branchName }}"
        [link]="true"
        (click)="detail(row)"
        styleClass="p-0"
      />
    </div>
    <div>
      <span>{{ row.memberId }}</span> &nbsp;
      <p-tag
        severity="info"
        value="{{ row.wdc ? row.wdc : 'Franchise' }}"
        [rounded]="true"
      />
    </div>
  </div> -->
</ng-template>

<ng-template
  #branchTpl
  let-row="row"
  let-value="value"
  let-column="column"
>
  <div class="grid gap-2">
    <span>
      {{ value.branchName }}
    </span>
    <p-tag
      severity="info"
      value="{{branchTypeEnumText[value.type]}}"
      [rounded]="true"
    />
  </div>
</ng-template>

<ng-template
  #countTpl
  let-row="row"
  let-value="value"
  let-column="column"
>
  <!-- <div class="grid gap-2"> -->
  <p class="mb-0">
    {{value?.firstname }} {{value?.lastname}}
  </p>
  <span>{{ row.cashierAt | libDate: "dateTime" }}</span>
</ng-template>

<ng-template
  #auditorTpl
  let-row="row"
  let-value="value"
  let-column="column"
>
  <!-- <div class="grid gap-2"> -->
  <p class="mb-0">
    {{value?.firstname}} {{value?.lastname}}
  </p>
  <span>{{ row.approvedAt | libDate: "dateTime" }}</span>
</ng-template>

<ng-template
  #sumAmountTpl
  let-row="row"
  let-value="value"
  let-column="column"
>
  {{value| number: "0.2"}}

</ng-template>

<ng-template
  #clerkTpl
  let-row="row"
  let-value="value"
  let-column="column"
>
  <!-- <div class="grid gap-2"> -->
  <p class="mb-0">
    {{value?.firstname }} {{value.lastname }}
  </p>
  <span>{{ row.createdAt| libDate: "dateTime" }}</span>
</ng-template>

<ng-template
  #activeStatusTpl
  let-row="row"
  let-value="value"
>
  <p class="mb-0">
    {{ pidByEnumText[row.paidBy] }}
  </p>
</ng-template>

<ng-template
  #actionTpl
  let-row="row"
  let-column="column"
>
  <div class="flex items-center justify-center gap-1">

    <!-- @if(row.status === statusPurchaseType.PendingReview){
    <p-button
      icon="fa fa-circle-check"
      severity="success"
      text
      [pTooltip]="'approve' | translate"
      appendTo="body"
      tooltipPosition="top"
      (click)="approveStatus(row)"
    />

    <p-button
      icon="fa fa-circle-xmark"
      severity="warn"
      text
      [pTooltip]="'rejected' | translate"
      appendTo="body"
      tooltipPosition="top"
      (click)="rejectedStatus(row)"
    />
    } -->

    <!-- <i class="fa-solid fa-money-bill"></i> -->
    @if(row.status === statusPurchaseType.PendingPayment){
    <p-button
      icon="fa fa-file-invoice"
      severity="info"
      text
      [pTooltip]="'paymentResultRecord' | translate"
      appendTo="body"
      tooltipPosition="top"
      (click)="onPaymentResultRecord(row)"
    />
    }


  </div>
</ng-template>

<lib-modal
  #modal
  [title]="'paymentResultRecord' | translate"
  modalType="form"
  (close)="onCloseForm()"
  (closeForm)="onCloseForm()"
  (submitForm)="formPaymentResultRecord.ngSubmit.emit(formPaymentResultRecord)"
>
  <!-- <div>content</div> -->
  @if(modal.isOpen()){

  <form
    #formPaymentResultRecord="ngForm"
    (ngSubmit)="onSubmit($event)"
    [class.ng-submitted]="formPaymentResultRecord.submitted"
  >
    <!-- <div class="formgrid md:grid-cols-2 sm:grid-cols-1">
      <div class="field ">
        <label
          for="nameTh"
          class="is-required"
        >{{"nameTh" | translate}}</label>
        <input
          type="text"
          pInputText
          id="nameTh"
          name="nameTh"
          [(ngModel)]="translationsTh.name"
          required
          [placeholder]="'placeholderInput' | translate: {placeholder: 'nameTh' | translate}"
        />
      </div>
    </div> -->

    <div class="formgrid md:grid-cols-2 sm:grid-cols-1 ">
      <div class="field col-span-1">
        <label
          for="file1"
          class="is-required"
        >{{"slipImage" | translate}}</label>
        <lib-file-image-upload
          aspectRatio="1/1"
          name="file1"
          [(ngModel)]="fileIcon"
          required
          [acceptFileType]="['.png','.jpg', '.jpeg', '.svg']"
        />
      </div>
    </div>
  </form>
  }
</lib-modal>